// extracted by mini-css-extract-plugin
module.exports = {"span":"SortRadio_span__2lQA2","input":"SortRadio_input__1ER4a"};